import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { error } from 'console';
import { combineLatest } from 'rxjs';
import { User } from 'src/app/interfaces/user';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-household-move',
  templateUrl: './household-move.component.html',
  styleUrl: './household-move.component.scss'
})
export class HouseholdMoveComponent {
  finishedLoadingUsers: boolean = false;
  currentUser: User;
  /**
   * The data to be displayed
   */
  dataSource: MatTableDataSource<any> = new MatTableDataSource();;
  displayedColumns = ['number', 'type', 'name', 'state', 'menu']; //  

  constructor(
    private route: ActivatedRoute,
    private businessuserService: BusinessuserService,
    private overlayService: OverlayService,

  ) {
    this.loadData();
  }

  moveToMainCustomer(newMainUser: User) {
    if (newMainUser.account.state == 'ACTIVE') {
      this.businessuserService.makeMainUser(newMainUser.publicId).subscribe({
        next: res => {
          console.log(res)
          this.overlayService.openSnackBar("Hauptkunde erfolgreich geändert!");
          this.loadData();
        },
        error: error => {
          console.log(error)
          this.overlayService.openSnackBar(error?.message);
        }
      })
    } else {
      this.overlayService.openSnackBar("Funktion ist nur für aktive Kunden verfügbar!")
    }

  }


  createNewOwnGroup(user: User) {
    if (user.account.state == 'ACTIVE') {
      this.businessuserService.createNewOwnGroup(user.publicId).subscribe({
        next: res => {
          console.log(res)
          this.overlayService.openSnackBar("Eigner Haushalt wurde gegründet!");
          this.loadData();
        },
        error: error => {
          console.log(error)
          this.overlayService.openSnackBar(error?.message);
        }
      })
    } else {
      this.overlayService.openSnackBar("Funktion ist nur für aktive Kunden verfügbar!")
    }

  }

  moveCustomer(user: User) {
    if (user.account.state == 'ACTIVE') {
      this.overlayService.openCustomerSearchDialog("Umziehen", "Kunde umziehen", "Umziehen", user.publicId);
    } else {
      this.overlayService.openSnackBar("Funktion ist nur für aktive Kunden verfügbar!")
    }
  }

  loadData() {
    this.currentUser = null;
    this.dataSource!.data = [];
    this.route.params.subscribe(params => {
      combineLatest([
        this.businessuserService.getBuissnessUser(params['id']),
        this.businessuserService.getGroupMemersByID(params['id']),
        this.businessuserService.getGroupHead(params['id']),
      ]).subscribe(([user, members, head]: any) => {
        console.log(head)
        console.log(members)
        this.currentUser = head;
        this.finishedLoadingUsers = true;
        this.dataSource = new MatTableDataSource(members);
      })
    })
  }
}
